/* ==========================================================================
   Cooperation Subpages Module (100% Dynamic Multi-Language Article Body)
   Full Scraped Articles Translated Across EN, CS, DE, ES, AR, PT
   ========================================================================== */

import { t, getLocale } from '../locales/i18n.js';
import { articleData } from '../locales/articleTranslations.js';
import { getSvgIcon } from '../components/Icons.js';

const coopHubTexts = {
  cs: {
    eyebrow: 'PARTNERSTVÍ A SPOLUPRÁCE',
    title: 'Spolupráce',
    desc: 'Zapojte se do našeho globálního ekosystému jako distributor, aktivní občan, systémový integrátor, investor nebo technologický či OEM partner.'
  },
  en: {
    eyebrow: 'PARTNERSHIP & COLLABORATION',
    title: 'Cooperation',
    desc: 'Join our global ecosystem as a distributor, active citizen, system integrator, investor, or technology & OEM partner.'
  },
  de: {
    eyebrow: 'PARTNERSCHAFT & KOOPERATION',
    title: 'Kooperation',
    desc: 'Werden Sie Teil unseres globalen Ökosystems als Distributor, aktiver Bürger, Systemintegrator, Investor oder Technologie- & OEM-Partner.'
  },
  es: {
    eyebrow: 'ASOCIACIÓN Y COLABORACIÓN',
    title: 'Cooperación',
    desc: 'Únase a nuestro ecosistema global como distribuidor, ciudadano activo, integrador de sistemas, inversor o socio tecnológico y OEM.'
  },
  it: {
    eyebrow: 'PARTNERSHIP E COLLABORAZIONE',
    title: 'Cooperazione',
    desc: 'Unisciti al nostro ecosistema globale come distributore, cittadino attivo, integratore di sistemi, investitore o partner tecnologico e OEM.'
  },
  pt: {
    eyebrow: 'PARCERIA E COLABORAÇÃO',
    title: 'Cooperação',
    desc: 'Junte-se ao nosso ecossistema global como distribuidor, cidadão ativo, integrador de sistemas, investidor ou parceiro tecnológico e OEM.'
  },
  ar: {
    eyebrow: 'الشراكة والتعاون',
    title: 'التعاون',
    desc: 'انضم إلى نظامنا البيئي العالمي كموزع أو مواطن نشط أو مكامل أنظمة أو مستثمر أو شريك تكنولوجي وOEM.'
  }
};

const investorPortalTranslations = {
  en: {
    breadcrumbHome: 'Home',
    breadcrumbCoop: 'Cooperation',
    heroBtn: '📈 Investment Portal (jalud.eu) ↗',
    boxEyebrow: 'Official Investor Portal',
    boxTitle: 'Looking for Comprehensive Investor Details & Metrics?',
    boxDesc: 'All detailed information, financial metrics, and strategic expansion materials for investors are available on our dedicated portal:',
    boxBtn: 'Visit Investor Portal →',
    sidebarBtn: '📈 Visit Investor Opportunity Portal (jalud.eu) →',
    mapBtn: '🗺️ View Global Distributors & Integrators Map →'
  },
  cs: {
    breadcrumbHome: 'Domů',
    breadcrumbCoop: 'Spolupráce',
    heroBtn: '📈 Investiční portál (jalud.eu) ↗',
    boxEyebrow: 'Oficiální portál pro investory',
    boxTitle: 'Hledáte podrobné informace a metriky pro investory?',
    boxDesc: 'Veškeré podrobné informace, finanční metriky a strategické expanzní materiály pro investory jsou k dispozici na našem dedikovaném portálu:',
    boxBtn: 'Přejít na portál pro investory →',
    sidebarBtn: '📈 Přejít na Portál investičních příležitostí (jalud.eu) →',
    mapBtn: '🗺️ Zobrazit globální mapu distributorů a integrátorů →'
  },
  de: {
    breadcrumbHome: 'Startseite',
    breadcrumbCoop: 'Kooperation',
    heroBtn: '📈 Investorenportal (jalud.eu) ↗',
    boxEyebrow: 'Offizielles Investorenportal',
    boxTitle: 'Suchen Sie umfassende Investorendaten & Kennzahlen?',
    boxDesc: 'Alle detaillierten Informationen, Finanzkennzahlen und strategischen Expansionsunterlagen für Investoren finden Sie auf unserem dedizierten Portal:',
    boxBtn: 'Investorenportal besuchen →',
    sidebarBtn: '📈 Investorenportal (jalud.eu) besuchen →',
    mapBtn: '🗺️ Globale Händler- & Integratorenkarte anzeigen →'
  },
  es: {
    breadcrumbHome: 'Inicio',
    breadcrumbCoop: 'Cooperación',
    heroBtn: '📈 Portal de Inversores (jalud.eu) ↗',
    boxEyebrow: 'Portal Oficial para Inversores',
    boxTitle: '¿Busca información detallada y métricas para inversores?',
    boxDesc: 'Toda la información detallada, métricas financieras y materiales de expansión estratégica están disponibles en nuestro portal dedicado:',
    boxBtn: 'Visitar Portal de Inversores →',
    sidebarBtn: '📈 Visitar Portal de Oportunidades de Inversión (jalud.eu) →',
    mapBtn: '🗺️ Ver mapa global de distribuidores e integradores →'
  },
  it: {
    eyebrow: 'PARTNERSHIP E COLLABORAZIONE',
    title: 'Cooperazione',
    desc: 'Unisciti al nostro ecosistema globale come distributore, cittadino attivo, integratore di sistemi, investitore o partner tecnologico e OEM.'
  },
  pt: {
    breadcrumbHome: 'Início',
    breadcrumbCoop: 'Cooperação',
    heroBtn: '📈 Portal do Investidor (jalud.eu) ↗',
    boxEyebrow: 'Portal Oficial do Investidor',
    boxTitle: 'Procurando informações detalhadas e métricas para investidores?',
    boxDesc: 'Todas as informações detalhadas, métricas financeiras e materiais de expansão estratégica para investidores estão disponíveis no nosso portal dedicado:',
    boxBtn: 'Visitar Portal do Investidor →',
    sidebarBtn: '📈 Visitar Portal de Investimentos (jalud.eu) →',
    mapBtn: '🗺️ Ver mapa global de distribuidores e integradores →'
  },
  ar: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbCoop: 'التعاون',
    heroBtn: '📈 بوابة المستثمرين (jalud.eu) ↗',
    boxEyebrow: 'بوابة المستثمرين الرسمية',
    boxTitle: 'هل تبحث عن معلومات تفصيلية ومؤشرات مالية للمستثمرين؟',
    boxDesc: 'جميع المعلومات التفصيلية والمؤشرات المالية واستراتيجيات التوسع للمستثمرين متاحة عبر بوابتنا المخصصة:',
    boxBtn: 'زيارة بوابة المستثمرين ←',
    sidebarBtn: '📈 زيارة بوابة الفرص الاستثمارية (jalud.eu) ←',
    mapBtn: '🗺️ عرض خريطة الموزعين والمكاملين حول العالم ←'
  }
};

const images = {
  'distributor': '/images/distributorsky-program-sed.png',
  'citizen': '/images/aktivni-obcane-bezpecne-mesto-sed.png',
  'integrator': '/images/systemovy-integrator-sed.png',
  'investor': '/images/investicni-partnerstvi-sed.png',
  'partner': '/images/oem-technologicke-partnerstvi-sed.png'
};

export function renderCooperationPage(routeKey = 'cooperation', onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';

  let coopKey = null;
  if (routeKey.includes('distributor') && !routeKey.includes('map')) coopKey = 'distributor';
  else if (routeKey.includes('citizen')) coopKey = 'citizen';
  else if (routeKey.includes('integrator')) coopKey = 'integrator';
  else if (routeKey.includes('investor')) coopKey = 'investor';
  else if (routeKey.includes('partner')) coopKey = 'partner';

  const locale = getLocale() || 'en';
  const localeArticles = articleData[locale] || articleData['en'];
  const invUi = investorPortalTranslations[locale] || investorPortalTranslations.en;
  const hubTexts = coopHubTexts[locale] || coopHubTexts.en;

  // RENDER DEDICATED SUBPAGE WITH DYNAMIC LANGUAGE ARTICLE TEXT
  if (coopKey && localeArticles[coopKey]) {
    const art = localeArticles[coopKey];
    const coopName = t(`cooperationTypes.${coopKey}`);
    const imgUrl = images[coopKey] || images['distributor'];

    container.innerHTML = `
      <section class="sed-section" style="background: linear-gradient(165deg, var(--navy-dark) 0%, var(--blue-dark) 100%); color: #ffffff; padding: 4.5rem 0 3.5rem;">
        <div class="sed-container">
          <div style="display: flex; gap: 0.5rem; align-items: center; font-size: 0.85rem; color: #cbd5e1; margin-bottom: 1.5rem; flex-wrap: wrap;">
            <a href="#home" style="color: #ffffff; text-decoration: none;" data-route="home">${invUi.breadcrumbHome}</a> /
            <a href="#cooperation" style="color: #ffffff; text-decoration: none;" data-route="cooperation">${invUi.breadcrumbCoop}</a> /
            <span style="color: var(--blue-primary); font-weight: 700;">${art.title || coopName}</span>
          </div>

          <div class="sed-detail-hero-grid">
            <div>
              <div class="sed-eyebrow" style="background: rgba(255,255,255,0.1); color: var(--blue-primary); border-color: rgba(255,255,255,0.2);">${art.eyebrow}</div>
              <h1 class="sed-page-hero-title">
                ${art.title}
              </h1>
              <p style="font-size: 1.15rem; color: #e2e8f0; line-height: 1.65; margin-bottom: 2rem;">
                ${art.lead}
              </p>
              <div style="display: flex; gap: 0.85rem; flex-wrap: wrap; align-items: center; margin-top: 1.75rem;">
                <a href="#contact" class="sed-btn sed-btn-hero sed-btn-primary" style="display: inline-flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; padding: 0 1.5rem; font-size: 0.95rem; font-weight: 700; border-radius: 10px; text-decoration: none;" data-route="contact">
                  ${t('common.applyContact')}
                </a>
                ${coopKey === 'investor' ? `
                  <a href="https://www.jalud.eu/investment-opportunity/" target="_blank" rel="noopener noreferrer" class="sed-btn sed-btn-hero" style="display: inline-flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; padding: 0 1.5rem; font-size: 0.95rem; font-weight: 700; border-radius: 10px; background: rgba(255,255,255,0.12); color: #ffffff; border: 1.5px solid rgba(255,255,255,0.6); backdrop-filter: blur(8px); text-decoration: none; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.22)'" onmouseout="this.style.background='rgba(255,255,255,0.12)'">
                    ${invUi.heroBtn}
                  </a>
                ` : ''}
                <a href="#cooperation" class="sed-btn sed-btn-hero" style="display: inline-flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; padding: 0 1.5rem; font-size: 0.95rem; font-weight: 700; border-radius: 10px; background: transparent; color: #ffffff; border: 1.5px solid rgba(255,255,255,0.35); text-decoration: none; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.1)'" onmouseout="this.style.background='transparent'" data-route="cooperation">
                  ${t('common.allTypes')}
                </a>
              </div>
            </div>

            <!-- Official Header Photo -->
            <div style="background: #ffffff; padding: 1rem; border-radius: 16px; box-shadow: 0 20px 50px rgba(0,0,0,0.3); text-align: center;">
              <img src="${imgUrl}" alt="${art.title}" style="width: 100%; max-height: 380px; object-fit: cover; border-radius: 10px;">
            </div>
          </div>
        </div>
      </section>

      <!-- Main Overview & Translated Body Content -->
      <section class="sed-section" style="background-color: #ffffff; padding: 4rem 0;">
        <div class="sed-container">
          <div class="sed-detail-main-grid">
            
            <!-- Left Column: Rich Technical & Commercial Article Details -->
            <div>
              <h2 style="font-size: 2rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 1.25rem; line-height: 1.25;">${art.h2}</h2>
              <p style="font-size: 1.05rem; line-height: 1.75; color: var(--text-dark); margin-bottom: 1.5rem;">${art.p1}</p>
              <p style="font-size: 1.05rem; line-height: 1.75; color: var(--text-dark); margin-bottom: 2rem;">${art.p2}</p>

              <!-- Strategic Investor Opportunity Callout Box -->
              ${coopKey === 'investor' ? `
                <div style="background: linear-gradient(135deg, #0a192f 0%, #1e3a8a 100%); border-radius: 16px; padding: 2.5rem; color: #ffffff; margin-bottom: 2.5rem; box-shadow: 0 10px 30px rgba(10, 25, 47, 0.2);">
                  <div class="sed-eyebrow" style="background: rgba(255,255,255,0.15); color: #38bdf8; border-color: rgba(255,255,255,0.3);">${invUi.boxEyebrow}</div>
                  <h3 style="font-size: 1.6rem; font-weight: 800; margin: 0.5rem 0 1rem; color: #ffffff;">${invUi.boxTitle}</h3>
                  <p style="font-size: 1.05rem; line-height: 1.65; color: #e2e8f0; margin-bottom: 1.5rem;">${invUi.boxDesc}</p>
                  <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
                    <a href="https://www.jalud.eu/investment-opportunity/" target="_blank" rel="noopener noreferrer" class="sed-btn sed-btn-primary" style="font-weight: 800; padding: 0.85rem 1.75rem;">${invUi.boxBtn}</a>
                  </div>
                </div>
              ` : ''}

              <h3 style="font-size: 1.45rem; font-weight: 800; color: var(--navy-dark); margin: 2rem 0 1.25rem;">${art.h3}</h3>
              <div class="sed-grid-2" style="gap: 1.25rem; margin-bottom: 2.5rem;">
                <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                  <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b1_title}</strong>
                  <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b1_desc}</span>
                </div>
                <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                  <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b2_title}</strong>
                  <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b2_desc}</span>
                </div>
                <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                  <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b3_title}</strong>
                  <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b3_desc}</span>
                </div>
                ${art.b4_title ? `
                  <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                    <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b4_title}</strong>
                    <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b4_desc}</span>
                  </div>
                ` : ''}
              </div>
            </div>

            <!-- Right Column: Key Takeaways & Action -->
            <div>
              <div class="sed-sidebar-card" style="position: sticky; top: 100px;">
                <h4 style="font-size: 1.15rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 1.25rem;">${t('common.coreBenefits') || (locale === 'cs' ? 'Hlavní přínosy' : 'Key Benefits')}</h4>
                <ul style="list-style: none; padding: 0; margin: 0 0 1.75rem 0; display: flex; flex-direction: column; gap: 0.85rem;">
                  ${art.benefits.map(b => `
                    <li style="display: flex; align-items: flex-start; gap: 0.65rem; font-size: 0.92rem; line-height: 1.5; color: var(--text-dark);">
                      <span style="color: var(--blue-primary); font-weight: 800; line-height: 1;">✓</span>
                      <span>${b}</span>
                    </li>
                  `).join('')}
                </ul>
                <a href="#contact" class="sed-btn sed-btn-primary" style="width: 100%; text-align: center;" data-route="contact">${t('common.applyContact')}</a>
                ${(coopKey === 'distributor' || coopKey === 'integrator') ? `
                  <a href="#distributors-map" class="sed-btn sed-btn-outline" style="width: 100%; text-align: center; margin-top: 0.75rem; color: var(--blue-primary); border-color: var(--blue-primary);" data-route="distributors-map">${invUi.mapBtn}</a>
                ` : ''}
              </div>
            </div>
          </div>
        </div>
      </section>
    `;

    container.querySelectorAll('[data-route]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (onNavigate) onNavigate(link.getAttribute('data-route'));
      });
    });

    return container;
  }

  // 6 HUB CARDS MATCHING DETEKCE CARD STYLE (White bg, 1.5px border, 4px colored top accent, tinted 48x48 icon square, uniform height, bottom btn)
  const getCardData = (l) => {
    const data = {
      cs: {
        map: {
          title: 'Mapa distributorů a systémových integrátorů',
          desc: 'Prohlédněte si interaktivní mapu certifikovaných distributorů a systémových integrátorů technologie Sound Event Detector po celém světě.'
        },
        citizen: {
          title: 'Občanská spolupráce pro bezpečnější města',
          desc: 'Zapojte občany a místní komunity do identifikace rizikových míst a podpořte spolupráci s městskou policií při řešení bezpečnostních událostí.'
        },
        distributor: {
          title: 'Distributorský program',
          desc: 'Rozšiřte své portfolio o technologii Sound Event Detector a nabídněte zákazníkům pokročilou akustickou detekci nebezpečných i provozních zvukových událostí.'
        },
        integrator: {
          title: 'Integrace SED do bezpečnostních systémů',
          desc: 'Rozšiřte stávající kamerové a bezpečnostní systémy o akustickou detekci a propojte SED s podporovanými kamerami, systémy VMS a dalšími technologiemi.'
        },
        investor: {
          title: 'Investiční partnerství',
          desc: 'Staňte se součástí rozvoje společnosti JALUD Embedded s.r.o. a podpořte globální expanzi její technologie akustické AI pro bezpečnostní využití.'
        },
        partner: {
          title: 'Technologické a OEM partnerství',
          desc: 'Spolupracujte s námi na vývoji řešení pro kamery, interkomy, chytré sloupy, robotické platformy a další zařízení s integrovanou technologií SED.'
        }
      },
      en: {
        map: {
          title: 'Distributors & System Integrators Map',
          desc: 'Explore the interactive map of certified Sound Event Detector distributors and system integrators worldwide.'
        },
        citizen: {
          title: 'Active Citizens & Municipalities',
          desc: 'Engage citizens and local communities in identifying risk areas and foster cooperation with municipal police in handling safety incidents.'
        },
        distributor: {
          title: 'Distributor Program',
          desc: 'Expand your product portfolio with Sound Event Detector and offer your customers advanced acoustic detection of security and operational sound events.'
        },
        integrator: {
          title: 'SED Integration into Security Systems',
          desc: 'Augment existing camera and security systems with acoustic detection by integrating SED with supported cameras, VMS platforms, and security technologies.'
        },
        investor: {
          title: 'Investment Partnership',
          desc: 'Become part of the growth of JALUD Embedded s.r.o. and support the global expansion of its acoustic AI technology for security applications.'
        },
        partner: {
          title: 'Technology & OEM Partnership',
          desc: 'Collaborate with us to develop integrated acoustic AI solutions for security cameras, intercoms, smart poles, robotic platforms, and edge devices.'
        }
      },
      de: {
        map: {
          title: 'Händler- & Systemintegratorenkarte',
          desc: 'Erkunden Sie die interaktive Karte zertifizierter Sound Event Detector-Distributoren und Systemintegratoren weltweit.'
        },
        citizen: {
          title: 'Aktive Bürger & Kommunen',
          desc: 'Binden Sie Bürger und lokale Gemeinschaften ein, um Gefahrenbereiche zu identifizieren und die Kooperation mit der Polizei zu stärken.'
        },
        distributor: {
          title: 'Distributorenprogramm',
          desc: 'Erweitern Sie Ihr Portfolio um den Sound Event Detector und bieten Sie Kunden fortschrittliche akustische Erkennung von Gefahren- und Betriebsgeräuschen.'
        },
        integrator: {
          title: 'SED-Integration in Sicherheitssysteme',
          desc: 'Erweitern Sie bestehende Video- und Sicherheitssysteme um akustische Erkennung und integrieren Sie SED in unterstützte Kameras und VMS-Plattformen.'
        },
        investor: {
          title: 'Investitionspartnerschaft',
          desc: 'Werden Sie Teil des Wachstums von JALUD Embedded s.r.o. und unterstützen Sie die weltweite Expansion unserer akustischen KI-Technologie.'
        },
        partner: {
          title: 'Technologie- & OEM-Partnerschaft',
          desc: 'Arbeiten Sie mit uns an der Entwicklung von Lösungen für Kameras, Gegensprechanlagen, intelligente Masten und Roboterplattformen mit integrierter SED-Technologie.'
        }
      },
      es: {
        map: {
          title: 'Mapa de Distribuidores e Integradores',
          desc: 'Consulte el mapa interactivo de distribuidores e integradores de sistemas certificados de Sound Event Detector en todo el mundo.'
        },
        citizen: {
          title: 'Ciudadanos Activos y Municipios',
          desc: 'Involucre a ciudadanos y comunidades locales para identificar zonas de riesgo y reforzar la cooperación con la policía municipal ante incidentes de seguridad.'
        },
        distributor: {
          title: 'Programa de Distribuidores',
          desc: 'Amplíe su cartera de productos con Sound Event Detector y ofrezca a sus clientes detección acústica avanzada de eventos de seguridad y operativos.'
        },
        integrator: {
          title: 'Integración de SED en Sistemas de Seguridad',
          desc: 'Amplíe sus sistemas de videovigilancia y seguridad con detección acústica e integre SED con cámaras compatibles, plataformas VMS y otras tecnologías.'
        },
        investor: {
          title: 'Asociación de Inversión',
          desc: 'Forme parte del crecimiento de JALUD Embedded s.r.o. y apoye la expansión global de su tecnología de IA acústica para aplicaciones de seguridad.'
        },
        partner: {
          title: 'Asociación Tecnológica y OEM',
          desc: 'Colabore con nosotros en el desarrollo de soluciones para cámaras, interfonos, postes inteligentes, plataformas robóticas y otros dispositivos con tecnología SED.'
        }
      },
      it: {
    eyebrow: 'PARTNERSHIP E COLLABORAZIONE',
    title: 'Cooperazione',
    desc: 'Unisciti al nostro ecosistema globale come distributore, cittadino attivo, integratore di sistemi, investitore o partner tecnologico e OEM.'
  },
  pt: {
        map: {
          title: 'Mapa de Distribuidores e Integradores',
          desc: 'Consulte o mapa interativo de distribuidores e integradores de sistemas certificados da tecnologia Sound Event Detector em todo o mundo.'
        },
        citizen: {
          title: 'Cidadãos Ativos e Municípios',
          desc: 'Envolva os cidadãos e as comunidades locais na identificação de áreas de risco e promova a cooperação com a polícia municipal na resolução de ocorrências.'
        },
        distributor: {
          title: 'Programa de Distribuidores',
          desc: 'Expanda o seu portfólio com o Sound Event Detector e disponibilize aos seus clientes deteção acústica avançada de eventos perigosos e operacionais.'
        },
        integrator: {
          title: 'Integração do SED em Sistemas de Segurança',
          desc: 'Amplie os sistemas de videovigilância e segurança existentes com deteção acústica e ligue o SED a câmaras compatíveis, plataformas VMS e outras tecnologias.'
        },
        investor: {
          title: 'Parceria de Investimento',
          desc: 'Faça parte do crescimento da JALUD Embedded s.r.o. e apoie a expansão global da sua tecnologia de IA acústica para aplicações de segurança.'
        },
        partner: {
          title: 'Parceria Tecnológica e OEM',
          desc: 'Colabore connosco no desenvolvimento de soluções para câmaras, intercomunicadores, postes inteligentes, plataformas robóticas e outros dispositivos com tecnologia SED.'
        }
      },
      ar: {
        map: {
          title: 'خريطة الموزعين ومكاملي الأنظمة',
          desc: 'استكشف الخريطة التفاعلية للموزعين المعتمدين ومكاملي أنظمة تقنية Sound Event Detector حول العالم.'
        },
        citizen: {
          title: 'المواطنون النشطون والبلديات',
          desc: 'أشرك المواطنين والمجتمعات المحلية في تحديد الأماكن المعرضة للمخاطر وعزز التعاون مع الشرطة البلدية في معالجة الحوادث الأمنية.'
        },
        distributor: {
          title: 'برنامج الموزعين',
          desc: 'وسّع محفظة منتجاتك باستخدام تقنية Sound Event Detector وقدّم لعملائك كشفاً صوتياً متقدماً للأحداث الأمنية والتشغيلية الخطرة.'
        },
        integrator: {
          title: 'دمج SED في الأنظمة الأمنية',
          desc: 'عزز أنظمة الكاميرات والأمان الحالية بالكشف الصوتي واربط SED بالكاميرات المدعومة وأنظمة إدارة الفيديو VMS والتقنيات الأمنية الأخرى.'
        },
        investor: {
          title: 'الشراكة الاستثمارية',
          desc: 'كن جزءاً من نمو شركة JALUD Embedded s.r.o. وادعم التوسع العالمي لتقنية الذكاء الاصطناعي الصوتي للاستخدامات الأمنية.'
        },
        partner: {
          title: 'الشراكة التكنولوجية وOEM',
          desc: 'تعاون معنا في تطوير حلول للكاميرات وأجهزة الاتصال الداخلي والأعمدة الذكية والمنصات الروبوتية والأجهزة المدمجة بتقنية SED.'
        }
      }
    };
    return data[l] || data.en;
  };

  const cardLocaleData = getCardData(locale);

  const hubCards = [
    {
      key: 'map',
      route: 'distributors-map',
      title: cardLocaleData.map.title,
      desc: cardLocaleData.map.desc,
      iconKey: 'coopMap',
      color: 'var(--blue-primary)',
      accent: 'var(--blue-primary)'
    },
    {
      key: 'citizen',
      route: 'cooperation-citizen',
      title: cardLocaleData.citizen.title,
      desc: cardLocaleData.citizen.desc,
      iconKey: 'coopCitizen',
      color: '#0284c7',
      accent: '#0284c7'
    },
    {
      key: 'distributor',
      route: 'cooperation-distributor',
      title: cardLocaleData.distributor.title,
      desc: cardLocaleData.distributor.desc,
      iconKey: 'coopDistributor',
      color: 'var(--blue-primary)',
      accent: 'var(--blue-primary)'
    },
    {
      key: 'integrator',
      route: 'cooperation-integrator',
      title: cardLocaleData.integrator.title,
      desc: cardLocaleData.integrator.desc,
      iconKey: 'coopIntegrator',
      color: '#10b981',
      accent: '#10b981'
    },
    {
      key: 'investor',
      route: 'cooperation-investor',
      title: cardLocaleData.investor.title,
      desc: cardLocaleData.investor.desc,
      iconKey: 'coopInvestor',
      color: '#f59e0b',
      accent: '#f59e0b'
    },
    {
      key: 'partner',
      route: 'cooperation-partner',
      title: cardLocaleData.partner.title,
      desc: cardLocaleData.partner.desc,
      iconKey: 'coopPartner',
      color: '#8b5cf6',
      accent: '#8b5cf6'
    }
  ];

  container.innerHTML = `
    <section class="sed-section" style="background: linear-gradient(165deg, var(--blue-light) 0%, #ffffff 70%); padding: 4.5rem 0 3rem;">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 820px;">
          <div class="sed-eyebrow">${hubTexts.eyebrow}</div>
          <h1 class="sed-page-hero-title">${hubTexts.title}</h1>
          <p class="sed-section-desc">${hubTexts.desc}</p>
        </div>
      </div>
    </section>

    <section class="sed-section" style="background-color: #ffffff; padding-bottom: 5rem;">
      <div class="sed-container">
        <div class="sed-grid-3" style="gap: 1.75rem;">
          ${hubCards.map(card => `
            <div class="sed-card" style="display: flex; flex-direction: column; justify-content: space-between; min-height: 320px; background: #ffffff; border: 1.5px solid var(--slate-line); border-top: 4px solid ${card.accent}; border-radius: 14px; padding: 2rem; box-shadow: 0 4px 15px rgba(0,0,0,0.03); transition: transform 0.2s, box-shadow 0.2s;" onmouseover="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 12px 28px rgba(0,0,0,0.08)';" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';">
              <div>
                <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
                  ${getSvgIcon(card.iconKey, 24, card.color)}
                </div>
                <h3 class="sed-card-title" style="font-size: 1.25rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 0.75rem; line-height: 1.35;">${card.title}</h3>
                <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0;">${card.desc}</p>
              </div>
              <div style="margin-top: 1.75rem;">
                <a href="#${card.route}" class="sed-btn sed-btn-primary" style="width: 100%; text-align: center; font-size: 0.88rem; font-weight: 700;" data-route="${card.route}">${t('common.learnMore')}</a>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    </section>
  `;

  container.querySelectorAll('[data-route]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (onNavigate) onNavigate(link.getAttribute('data-route'));
    });
  });

  return container;
}
